/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'


export class CheckboxToggle extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.any,
    checked: PropTypes.bool.isRequired,
    onStateLabel: PropTypes.string,
    offStateLabel: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  render() {
    return (
      <div className={`slds-form-element ${this.props.className ? this.props.className : ''}`}>
        <label className="slds-checkbox_toggle slds-grid">
          {this.props.label &&
            <span className="slds-form-element__label slds-m-bottom_none slds-p-top_xxx-small">
              {this.props.label}
            </span>
          }
          <input
            id={this.props.id}
            type="checkbox"
            name="checkbox"
            aria-describedby="toggle-desc"
            checked={this.props.checked}
            onChange={this.props.onChange}
          />
          <span id="toggle-desc" className="slds-checkbox_faux_container" aria-live="assertive" htmlFor={this.props.id}>
            <span className="slds-checkbox_faux"></span>
            {this.props.onStateLabel && this.props.offStateLabel &&
              [
                <span className="slds-checkbox_on" key='label_on'>
                  {this.props.onStateLabel}
                </span>,
                <span className="slds-checkbox_off" key='label_off'>
                  {this.props.offStateLabel}
                </span>
              ]
            }
          </span>
        </label>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/checkbox-toggle/index.js